// Sincronizza la lingua i18n con il prefisso URL (/en, /de, ...) e gestisce
// il redirect automatico alla prima visita in base al Paese del visitatore.
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ALL_LANGUAGES,
  DEFAULT_LANGUAGE,
  LANG_PREF_KEY,
  isBotAgent,
  isPublicPath,
  splitLangPath,
} from "../i18n/urls";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const LanguageRouter = () => {
  const { i18n } = useTranslation();
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { lang: urlLang, path: basePath } = splitLangPath(pathname);
    const current = (i18n.resolvedLanguage || i18n.language || "").split("-")[0];

    if (urlLang) {
      // Le route private non hanno versioni localizzate: rimanda alla URL senza prefisso
      if (!isPublicPath(basePath)) {
        navigate(`${basePath}${search}${hash}`, { replace: true });
        return;
      }
      if (current !== urlLang) i18n.changeLanguage(urlLang);
      try {
        localStorage.setItem(LANG_PREF_KEY, urlLang);
      } catch (e) {}
      return;
    }

    // URL senza prefisso = versione italiana (default)
    const forceDefault = () => {
      if (current !== DEFAULT_LANGUAGE) i18n.changeLanguage(DEFAULT_LANGUAGE);
    };

    if (isBotAgent() || !isPublicPath(basePath)) {
      forceDefault();
      return;
    }

    let pref = null;
    try {
      pref = localStorage.getItem(LANG_PREF_KEY);
    } catch (e) {
      pref = null;
    }

    if (pref && ALL_LANGUAGES.includes(pref)) {
      if (pref !== DEFAULT_LANGUAGE) {
        navigate(`/${pref}${basePath === "/" ? "" : basePath}${search}${hash}`, { replace: true });
      } else {
        forceDefault();
      }
      return;
    }

    // Prima visita: rileva la lingua dal Paese (IP) lato backend
    let cancelled = false;
    fetch(`${BACKEND}/api/geo/language`)
      .then((r) => r.json())
      .then((data) => {
        if (cancelled) return;
        const detected = data?.language;
        if (detected && ALL_LANGUAGES.includes(detected) && detected !== DEFAULT_LANGUAGE) {
          try {
            localStorage.setItem(LANG_PREF_KEY, detected);
          } catch (e) {}
          i18n.changeLanguage(detected);
          navigate(`/${detected}${basePath === "/" ? "" : basePath}${search}${hash}`, {
            replace: true,
          });
        } else {
          forceDefault();
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
};

export default LanguageRouter;
